import React, { useState } from "react";

export default function AltriDocumentiUpload() {
  const [uploadedDocs, setUploadedDocs] = useState([]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files || []);
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    const maxSize = 1024 * 1024; // 1 MB

    const validFiles = files.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        alert(`❌ Il file "${file.name}" non è in un formato supportato.`);
        return false;
      }
      if (file.size > maxSize) {
        alert(
          `⚠️ Il file "${file.name}" supera la dimensione massima di 1 MB.`
        );
        return false;
      }
      return true;
    });

    setUploadedDocs((prev) => [...prev, ...validFiles]);
  };

  const handleDelete = (index) => {
    setUploadedDocs((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="altri-doc-container">
      <label style={{marginBottom: "2px"}}>Altri Documenti</label>
      <p className="altri-doc-subinfo">
        (Carica i documenti richiesti in formato <strong>JPG</strong>,{" "}
        <strong>PNG</strong> o <strong>PDF</strong>. La dimensione massima
        consentita è di <strong>1 MB per file</strong>).
      </p>

      <div className="altri-doc-upload">
      
        <input
          id="document-upload"
          type="file"
          accept=".jpg,.jpeg,.png,.pdf"
          multiple
          onChange={handleFileUpload}
          className="altri-doc-input"
        />
      </div>

      {uploadedDocs.length > 0 && (
        <div className="altri-doc-list">
          <h4 className="altri-doc-list-title">Documenti caricati</h4>
          <ul className="altri-doc-items">
            {uploadedDocs.map((file, index) => (
              <li key={index} className="altri-doc-item">
                <div className="altri-doc-fileinfo">
                  <span className="altri-doc-icon">📄</span>
                  <span className="altri-doc-name">{file.name}</span>
                </div>
                <div className="altri-doc-actions">
                  <span className="altri-doc-size">
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </span>
                  <button
                    onClick={() => handleDelete(index)}
                    className="altri-doc-delete"
                    title="Elimina documento"
                  >
                    ❌
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
